import _get from "lodash/get";
import { AnyAction } from "redux";
import * as AT from "./actionTypes";
import { AddressState } from "../../../../models/state";
import { fulfilled, pending } from "../../app/utils";

const getFieldsToClear = (field: string) => {
    switch (field) {
        case "zipCode":
            return ["streetName", "streetNumber", "floor", "apartment", "vaid"];
        case "streetName":
            return ["streetNumber", "floor", "apartment", "vaid"];
        case "streetNumber":
            return ["floor", "apartment", "vaid"];
        case "floor":
            return ["apartment", "vaid"];
        default:
            return [];
    }
};

const getStreetData = (field: string) => {
    switch (field) {
        case "zipCode":
            return {
                streetNames: [],
                streetNumbers: [],
            };
        case "streetName":
            return {
                streetNumbers: [],
            };
        default:
            return {};
    }
};

const initialState: AddressState = {
    streetNames: [],
    streetNumbers: [],
    selected: {
        zipCode: "",
        streetName: "",
        streetNumber: "",
        floor: "",
        apartment: "",
        city: "",
        vaid: undefined,
    },
    fields: {
        zipCode: "",
        streetName: "",
        streetNumber: "",
        floor: "",
        apartment: "",
        city: "",
    },
    isCustomAddressSelected: false,
    setVaidSuccess: false,
};

const reducer = (state = initialState, action: AnyAction): AddressState => {
    switch (action.type) {
        case AT.FWA_SET_SELECTED_FIELD:
            return {
                ...state,
                selected: {
                    ...state.selected,
                    [action.field]: action.value,
                },
                fields: {
                    ...state.fields,
                    [action.field]: action.value,
                },
            };
        case AT.FWA_UPDATE_FIELD:
            return {
                ...state,
                ...getStreetData(action.field),
                fields: {
                    ...state.fields,
                    [action.field]: action.value,
                    ...Object.assign({}, ...getFieldsToClear(action.field).map((field) => ({ [field]: "" }))),
                },
                selected: {
                    ...state.selected,
                    [action.field]: "",
                    ...Object.assign({}, ...getFieldsToClear(action.field).map((field) => ({ [field]: "" }))),
                },
            };
        case pending(AT.FWA_LOOKUP_STREET):
            return {
                ...state,
                streetNames: [],
                streetNumbers: [],
            };
        case fulfilled(AT.FWA_LOOKUP_STREET):
            return {
                ...state,
                streetNames: _get(action, "payload.data") || [],
                streetNumbers: [],
            };
        case fulfilled(AT.FWA_SEARCH_ADDRESS):
            return {
                ...state,
                streetNumbers: _get(action, "payload") || [],
            };
        case fulfilled(AT.FWA_CHECK_ADDRESS):
            return {
                ...state,
                setVaidSuccess: action.payload.success,
            };
        case AT.FWA_SET_CUSTOM_ADDRESS_CHECKED:
            return {
                ...state,
                isCustomAddressSelected: !!action.value,
            };
        default:
            return state;
    }
};

export default reducer;
